import { useEffect, useMemo, useState } from "react";
import { TimeChart, TimeChartData, TimeChartProps } from "./TimeChart";
import clone from "just-clone";
import { useAtom } from "jotai";
import { chartColorsAtom } from "../../atoms/chart-colors-atom";

export function TimeChartWithStableColors({ data }: TimeChartProps) {
  const colors = useMemo(
    () => [
      "#5470c6",
      "#91cc75",
      "#fac858",
      "#ee6666",
      "#73c0de",
      "#3ba272",
      "#fc8452",
      "#9a60b4",
      "#ea7ccc",
      "#bda29a",
      "#6e7074",
      "#546570",
      "#c4ccd3",
      "#f4a460",
      "#8b0000",
      "#4682b4",
      "#228b22",
      "#daa520",
      "#ff69b4",
      "#20b2aa",
      "#cd5c5c",
      "#7b68ee",
      "#ffb6c1",
      "#2e8b57",
      "#ff6347",
    ],
    []
  );

  const [assignedColors, setAssignedColors] = useAtom(chartColorsAtom);
  const [coloredData, setColoredData] = useState<TimeChartData[]>([]);

  useEffect(() => {
    const tempData = clone(data);

    for (const assignedColorSeriesName of Object.keys(assignedColors)) {
      if (tempData.map((x) => x.name).indexOf(assignedColorSeriesName) === -1) {
        delete assignedColors[assignedColorSeriesName];
      }
    }

    for (const series of tempData) {
      if (!series.color && series.name) {
        const storedColor = assignedColors[series.name];

        if (storedColor) {
          series.color = storedColor.toString();
        } else {
          const nextColor = colors.find(
            (c) => !Object.values(assignedColors).includes(c)
          );
          if (nextColor) {
            series.color = nextColor.toString();
            assignedColors[series.name] = nextColor;
          }
        }
      }
    }

    setAssignedColors(assignedColors);
    setColoredData(tempData);
  }, [data, assignedColors, colors, setAssignedColors, setColoredData]);

  return coloredData.length > 0 ? <TimeChart data={coloredData} /> : <></>;
}
